import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { MultiSelect } from "react-multi-select-component"
import { Container } from '../resources'
import { PostCard } from './postCard'
import { useSelector, useDispatch } from 'react-redux'
import { createCollection, getCollection, deleteCollection } from '../../../features/collections/collectionSlice'

// import Spinner from '../../../../components/spinner'




const DashHome = () => {
  const [selected, setSelected] = useState([]);

  const dispatch = useDispatch();

  const { user } = useSelector(state => state?.auth);
  const { collections, isLoading, isError, collectionCreatedStatus, isSuccess, message } = useSelector(state => state?.collections);

  useEffect(() => {
       
    dispatch(getCollection());

}, [collectionCreatedStatus]);



  return (
    <Container>
      <h3>Hello and Welcome {user && user.userFirstName}</h3>

      <Intro>  <p>My Collections</p> </Intro>
      <CardWrap>        
        
        { collections.length > 0 ? (
          
          <>
           {
              collections.map((resource) => {

                // console.log(resource);
                return (

                  // <TableData key={resource._id} resource={resource} />
                <PostCard resource={resource} key={resource.resourceCollectionItemId} 
                  // resourceImage={resource.resourceId?.resourceImage} 
                  // resourceTitle={resource.resourceCollectionItemId?.resourceTitle}
                  // resourceDescription={resource.resourceId?.resourceAuthors}
                />               
                  )
                })
            }    
          
          </>

         ) : ( <h4>You have not stored any collection</h4> )

         }

        
        
        
        
        
        
        
        
        
        
        
        
        {/* <PostCard />
        <PostCard />
        <PostCard />
        <PostCard />
        <PostCard />
        <PostCard />
        <PostCard /> */}
      </CardWrap>

      
    </Container>
  )
}


const Intro = styled.section`

  margin-top: 4rem;

  & p{
    font-weight: 700;
  }
  
`

const CardWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: space-between;
  /* flex-wrap: wrap; */
  width: 90%;
  margin-bottom: 3rem;

  @media screen and (max-width: 600px){
            justify-content: center;
            display: flex;
            flex-wrap: wrap;
        }

`

export {DashHome}